<template>
  <el-dialog :visible.sync="visible"
             title="重置密码">
    <div style="text-align: center;">
      <div>确定重置“{{dataForm.name}}”的登录密码吗？</div>
      <br/>
      <br/>
      <div>每天限重置三次</div>
      <div>每次间隔不低于30分钟</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dataFormSubmitHandle()">确 定</el-button>
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      dataListLoading: false,
      dataForm: {
        name: '',
        custId: ''
      }
    }
  },
  methods: {
    init () {
      this.visible = true
    },
    // 删除
    dataFormSubmitHandle () {
      if (this.dataListLoading) {
        return true
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/custorg/resetPassword/${this.dataForm.custId}`)
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code === 0) {
            this.visible = false
            this.$message.success('操作成功')
            this.$emit('refreshDataList')
          }
        }).catch(() => {
          this.dataListLoading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
